import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { isPPLFrontend } from '@utils/app-paths';
import { stripDataQuery, stripEventQuery, stripRecordingEventQuery } from '@utils/sentry-strip-url-query';
import { createTracesSampler } from '@utils/sentry-traces-sampler';
import axios from 'axios';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampler: createTracesSampler({ environment: import.meta.env.VITE_ENVIRONMENT, isPPL: isPPLFrontend }),
  enableLogs: false,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: { request: false, response: false },
    httpBodies: [],
    genAI: { inputs: false, outputs: false },
  },
  beforeBreadcrumb: stripDataQuery,
  beforeSendSpan: stripDataQuery,
  beforeSend: (event, hint) => (axios.isCancel(hint.originalException) ? null : event),
  ignoreErrors: ['Non-Error promise rejection captured with value: Widget', 'UserAlreadyAuthenticatedException'],
  denyUrls: [/extensions\//i, /^chrome(-extension)?:\/\//i, /^moz-extension:\/\//i, /^safari-web-extension:\/\//i],
});

Sentry.addEventProcessor(stripEventQuery);
Sentry.setTag('client', import.meta.env.VITE_CLIENT);

if (import.meta.env.VITE_ENVIRONMENT === 'prod') {
  import('@sentry/replay').then(({ replayIntegration }) =>
    Sentry.addIntegration(replayIntegration({ beforeAddRecordingEvent: stripRecordingEventQuery })),
  );
}
